import { Component, Input, OnInit } from '@angular/core';
import { GroupLotItem } from '../../../services/base-actions/items-inventory.service';

@Component({
  selector: 'app-items-inventory-group-table',
  templateUrl: './items-inventory-group-table.component.html',
  styleUrl: './items-inventory-group-table.component.scss',
})
export class ItemsInventoryGroupTableComponent implements OnInit {
  @Input() groupedLotItems: GroupLotItem[] = [];

  ngOnInit(): void {
    console.log(this.groupedLotItems);
  }
}
